import React from 'react';

const TableHeading = ({heading}) => (
  <h5 className='table-heading'>
    <span>{heading}</span>
  </h5>
)

export default TableHeading;